import { loader } from 'graphql.macro'

export default function paymentTerms ({ dataLoaders }) {
  const schema = loader('./paymentTerms.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema)
}
